import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../utils/cn';
import { Card, CardBody } from './Card';

export const Collapsible = React.forwardRef(function Collapsible(
  { title, defaultOpen = false, className, children, ...props },
  ref,
) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Card ref={ref} className={className} {...props}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between px-6 py-4"
      >
        <h3 className="text-base font-semibold text-fg">{title}</h3>
        <ChevronDown
          size={18}
          className={cn(
            'text-fg-tertiary transition-transform duration-200',
            open && 'rotate-180',
          )}
        />
      </button>
      {open && (
        <CardBody className="border-t border-edge-strong pt-4">
          {children}
        </CardBody>
      )}
    </Card>
  );
});
